/* eslint-disable import/no-extraneous-dependencies */
import { Gesture, focus } from '@talend/react-a11y';

export { focus };
export default Gesture;
